
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"13","height":"13","rx":"2.5","stroke":"#D5DBE3"}}),_c('path',{attrs:{"d":"M9.762 3L6 7.262 4.238 5.415 3 6.785 6 10l5-5.631L9.762 3z","fill":"#D5DBE3"}})])
          )
        }
      }
    